module.exports = __webpack_public_path__ + "img/mall.c0230541.jpg";